import styled from 'styled-components'

export const CheckBoxContainer = styled.div`
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;

  /* Hide the browser's default checkbox */
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  label {
    cursor: pointer;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 15px;
    width: 15px;
    border: 1px solid #75b3cc;
    box-sizing: border-box;
    border-radius: 3px;
  }

  input:checked ~ .checkmark {
    background-color: #75b3cc;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkmark:after {
    left: 4px;
    top: 0px;
    width: 3px;
    height: 8px;
    border: solid white;
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(51.34deg);
    -ms-transform: rotate(51.34deg);
    transform: rotate(51.34deg);
  }
`



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.style.js